import { createAction, props } from '@ngrx/store';
import { IDigitalProduct } from '../../digitalProduct/models/digitalProduct.model';

export const getSubscriptions = createAction('[Subscription] Get Subscriptions');
export const getSubscriptionsSuccess = createAction('[Subscription] Get Subscriptions success', (subscriptionList: IDigitalProduct[]) => ({ subscriptionList }));
export const getSubscriptionsFailure = createAction('[Subscription] Get Subscriptions failure', props<{ error: string }>());

export const getSubscription = createAction('[Subscription] Get Subscription', (subscriptionId: string) => ({ subscriptionId }));
export const getSubscriptionSuccess = createAction('[Subscription] Get Subscription success', (subscription: IDigitalProduct) => ({ subscription }));
export const getSubscriptionFailure = createAction('[Subscription] Get Subscription failure', props<{ error: string }>());

export const subscriptionActions = {
    getSubscriptions,
    getSubscriptionsSuccess,
    getSubscriptionsFailure,
    getSubscription,
    getSubscriptionSuccess,
    getSubscriptionFailure
};
